import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _typeof from 'babel-runtime/helpers/typeof';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var Split = function (_PureComponent) {
  _inherits(Split, _PureComponent);

  function Split(props) {
    _classCallCheck(this, Split);

    var _this = _possibleConstructorReturn(this, (Split.__proto__ || Object.getPrototypeOf(Split)).call(this, props));

    var SplitLoadingComponent = props.SplitLoadingComponent;

    _this.state = {
      SplitComponent: SplitLoadingComponent,
      splitError: null,
      splitErrorInfo: null
    };
    return _this;
  }

  _createClass(Split, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          loadSplitComponentForPath = _props.loadSplitComponentForPath,
          splitComponentPath = _props.splitComponentPath;


      var that = this;

      loadSplitComponentForPath(splitComponentPath, function (component) {
        if (component && component.default) {
          that.setSplitComponent(component.default);
        } else if (component) {
          that.setSplitComponent(component);
        } else {
          console.error('Split error for \'' + splitComponentPath + '\' - the loaded component was invalid: ', typeof component === 'undefined' ? 'undefined' : _typeof(component), component);
          that.setSplitError({ message: 'the loaded component type was invalid', type: typeof component === 'undefined' ? 'undefined' : _typeof(component) }, { component: component });
        }
      }, function (loadingError) {
        console.error('Split error for \'' + splitComponentPath + '\' - a loading error occurred: ', loadingError);
        that.setSplitError(loadingError);
      });
    }
  }, {
    key: 'setSplitComponent',
    value: function setSplitComponent(SplitComponent) {
      var _this2 = this;

      if (!this._unmounted) {
        var splitLoadDelay = this.props.splitLoadDelay;

        if (splitLoadDelay !== void 0 && splitLoadDelay > 0) {
          if (splitLoadDelay !== Number.Infinity && splitLoadDelay !== Number.POSITIVE_INFINITY) {
            if (!this._unmounted) {
              setTimeout(function () {
                _this2.setState({ SplitComponent: SplitComponent, splitError: null, splitErrorInfo: null });
              }, splitLoadDelay);
            }
          }
        } else {
          this.setState({ SplitComponent: SplitComponent, splitError: null, splitErrorInfo: null });
        }
      }
    }
  }, {
    key: 'setSplitError',
    value: function setSplitError(splitError) {
      var splitErrorInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var splitErrorCallback = this.props.splitErrorCallback;

      if (splitErrorCallback) {
        splitErrorCallback(splitError, splitErrorInfo);
      }
      if (!this._unmounted) {
        var SplitErrorComponent = this.props.SplitErrorComponent;

        this.setState({ SplitComponent: SplitErrorComponent, splitError: splitError, splitErrorInfo: splitErrorInfo });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unmounted = true;
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      var splitComponentPath = this.props.splitComponentPath;

      console.error('Split error for \'' + splitComponentPath + '\' - an error was caught: ', error, info);
      this.setSplitError(error, info);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loadSplitComponentForPath = _props2.loadSplitComponentForPath,
          splitComponentPath = _props2.splitComponentPath,
          otherProps = _objectWithoutProperties(_props2, ['loadSplitComponentForPath', 'splitComponentPath']);

      var _state = this.state,
          SplitComponent = _state.SplitComponent,
          splitError = _state.splitError,
          splitErrorInfo = _state.splitErrorInfo;
      // Leave the SplitLoadingComponent and SplitErrorComponent props for children to use

      var childProps = _extends({}, otherProps);
      if (splitError !== null || splitErrorInfo !== null) {
        childProps.splitError = splitError;
        childProps.splitErrorInfo = splitErrorInfo;
      }
      return React.createElement(SplitComponent, childProps);
    }
  }]);

  return Split;
}(PureComponent);

Split.propTypes = {
  SplitLoadingComponent: PropTypes.func.isRequired,
  SplitErrorComponent: PropTypes.func.isRequired,
  loadSplitComponentForPath: PropTypes.func.isRequired,
  splitComponentPath: PropTypes.string.isRequired,
  splitErrorCallback: PropTypes.func
};
export default Split;